import React__default from 'react';
import PropTypes from 'prop-types';
import SvgAnfkidsIcon from './logos/AnfkidsIcon.js';
import SvgGillyHicksLogotypeSmall from './logos/GillyHicksLogotypeSmall.js';
import SvgGillyHicksLogotype from './logos/GillyHicksLogotype.js';
import SvgGillyHicksMonogram from './logos/GillyHicksMonogram.js';
import SvgGillyHicksStackedSmall from './logos/GillyHicksStackedSmall.js';
import SvgGillyHicksStacked from './logos/GillyHicksStacked.js';
import SvgHcoLogoHorizontal from './logos/HcoLogoHorizontal.js';
import SvgHcoLogoStacked from './logos/HcoLogoStacked.js';
import SvgKidsLogoHorizontal from './logos/KidsLogoHorizontal.js';
import SvgLogoBlock from './logos/LogoBlock.js';
import SvgLogoHcoHorizontalSeagull from './logos/LogoHcoHorizontalSeagull.js';
import SvgLogoHorizontal from './logos/LogoHorizontal.js';
import SvgLogoKidsFull from './logos/LogoKidsFull.js';
import SvgLogoStacked from './logos/LogoStacked.js';
import SvgLogoYpbHorizontal from './logos/LogoYpbHorizontal.js';
import SvgLogoYpbMonogram from './logos/LogoYpbMonogram.js';
import SvgLogoYpbStacked from './logos/LogoYpbStacked.js';
import SvgSeagull from './logos/Seagull.js';

var propTypes = {
  kind: PropTypes.oneOf(['anf', 'anf-stacked', 'anf-monogram', 'ypb', 'ypb-monogram', 'ypb-stacked', 'kids', 'kids-stacked', 'kids-monogram', 'hco', 'hco-stacked', 'hco-seagull', 'hco-seagull-horizontal', 'gh', 'gh-monogram', 'gh-small', 'gh-stacked', 'gh-stacked-small', 'st', 'st-monogram', 'st-stacked']).isRequired,
  isSVG: PropTypes.bool
};
function Logo(_ref) {
  var kind = _ref.kind,
    _ref$isSVG = _ref.isSVG,
    isSVG = _ref$isSVG === void 0 ? false : _ref$isSVG;
  var settingsByKind = {
    anf: {
      labelText: 'abercrombie and fitch',
      dataBrand: 'anf',
      svg: /*#__PURE__*/React__default.createElement(SvgLogoHorizontal, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'anf-stacked': {
      labelText: 'abercrombie and fitch',
      dataBrand: 'anf',
      dataType: 'stacked',
      svg: /*#__PURE__*/React__default.createElement(SvgLogoStacked, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'anf-monogram': {
      labelText: 'abercrombie and fitch',
      dataBrand: 'anf',
      dataType: 'monogram',
      svg: /*#__PURE__*/React__default.createElement(SvgLogoBlock, {
        width: "100%",
        fill: "currentColor"
      })
    },
    gh: {
      labelText: 'gilly hicks',
      dataBrand: 'gh',
      svg: /*#__PURE__*/React__default.createElement(SvgGillyHicksLogotype, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'gh-monogram': {
      labelText: 'gilly hicks',
      dataBrand: 'gh',
      dataType: 'monogram',
      svg: /*#__PURE__*/React__default.createElement(SvgGillyHicksMonogram, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'gh-small': {
      labelText: 'gilly hicks',
      dataBrand: 'gh',
      dataType: 'small',
      svg: /*#__PURE__*/React__default.createElement(SvgGillyHicksLogotypeSmall, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'gh-stacked': {
      labelText: 'gilly hicks',
      dataBrand: 'gh',
      dataType: 'stacked',
      svg: /*#__PURE__*/React__default.createElement(SvgGillyHicksStacked, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'gh-stacked-small': {
      labelText: 'gilly hicks',
      dataBrand: 'gh',
      dataType: 'stacked-small',
      svg: /*#__PURE__*/React__default.createElement(SvgGillyHicksStackedSmall, {
        width: "100%",
        fill: "currentColor"
      })
    },
    hco: {
      labelText: 'hollister co.',
      dataBrand: 'hol',
      svg: /*#__PURE__*/React__default.createElement(SvgHcoLogoHorizontal, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'hco-seagull-horizontal': {
      labelText: 'hollister co.',
      dataBrand: 'hol',
      dataType: 'seagull',
      svg: /*#__PURE__*/React__default.createElement(SvgLogoHcoHorizontalSeagull, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'hco-seagull': {
      labelText: 'hollister co.',
      dataBrand: 'hol',
      dataType: 'seagull-logo',
      svg: /*#__PURE__*/React__default.createElement(SvgSeagull, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'hco-stacked': {
      labelText: 'hollister co.',
      dataBrand: 'hol',
      dataType: 'stacked',
      svg: /*#__PURE__*/React__default.createElement(SvgHcoLogoStacked, {
        width: "100%",
        fill: "currentColor"
      })
    },
    kids: {
      labelText: 'abercrombie kids',
      dataBrand: 'kids',
      svg: /*#__PURE__*/React__default.createElement(SvgKidsLogoHorizontal, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'kids-stacked': {
      labelText: 'abercrombie kids',
      dataBrand: 'kids',
      dataType: 'stacked',
      svg: /*#__PURE__*/React__default.createElement(SvgLogoKidsFull, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'kids-monogram': {
      labelText: 'abercrombie kids',
      dataBrand: 'kids',
      dataType: 'monogram',
      svg: /*#__PURE__*/React__default.createElement(SvgAnfkidsIcon, {
        width: "100%",
        fill: "currentColor"
      })
    },
    st: {
      labelText: 'social tourist',
      dataBrand: 'st'
    },
    'st-monogram': {
      labelText: 'social tourist',
      dataBrand: 'st',
      dataType: 'monogram'
    },
    'st-stacked': {
      labelText: 'social tourist',
      dataBrand: 'st',
      dataType: 'stacked'
    },
    ypb: {
      labelText: 'your personal best',
      dataBrand: 'ypb',
      svg: /*#__PURE__*/React__default.createElement(SvgLogoYpbHorizontal, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'ypb-monogram': {
      labelText: 'your personal best',
      dataBrand: 'ypb',
      dataType: 'monogram',
      svg: /*#__PURE__*/React__default.createElement(SvgLogoYpbMonogram, {
        width: "100%",
        fill: "currentColor"
      })
    },
    'ypb-stacked': {
      labelText: 'your personal best',
      dataBrand: 'ypb',
      dataType: 'stacked',
      svg: /*#__PURE__*/React__default.createElement(SvgLogoYpbStacked, {
        width: "100%",
        fill: "currentColor"
      })
    }
  };
  var _settingsByKind$kind = settingsByKind[kind],
    labelText = _settingsByKind$kind.labelText,
    dataBrand = _settingsByKind$kind.dataBrand,
    dataType = _settingsByKind$kind.dataType,
    svg = _settingsByKind$kind.svg;
  return isSVG ? svg : /*#__PURE__*/React__default.createElement("div", {
    className: "logo",
    "data-testid": "logo"
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-label": labelText,
    className: "logo-icon",
    "data-brand": dataBrand,
    "data-type": dataType,
    role: "img"
  }));
}
Logo.propTypes = propTypes;

export { Logo as default };
//# sourceMappingURL=Logo.js.map
